import { APIRoute } from '@/modules/utils'

export const Route = (): APIRoute => ({
  method: 'POST',
  path: '/v3/reviews/:reviewId/answer',
})

export type Body = { content: string }

export type Response = never
